var _defs, _polyline, _line, _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLactose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:none;}.cls-1,.cls-2{stroke:#333;stroke-linecap:round;stroke-width:7px;}.cls-1{stroke-linejoin:round;}.cls-2{stroke-linejoin:bevel;}.cls-3{stroke:#d00000;stroke-miterlimit:10;stroke-width:10px;}"))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "141.91 123.82 141.91 188.71 115.97 188.71"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 141.91,
    y1: 102.34,
    x2: 141.91,
    y2: 112.61
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 99.5,
    y: 41.38,
    width: 43.89,
    height: 19.75,
    rx: 8.11
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M120.36,171.91v58.84s.31,6.26,7.84,6.26h50.15s6.27,0,6-6.57c-.28-5.9-.05-80.92,0-96.2a6.67,6.67,0,0,0-1.83-4.6c-4.37-4.59-15.07-16.39-15.57-22.36l-.14-12-27.29.22v12.21s-4,13.65-15.78,23.09a6.51,6.51,0,0,0-2.48,4.9Z",
    transform: "translate(-31.21 -34.19)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M266.21,154.19a115,115,0,1,1-115-115A115,115,0,0,1,266.21,154.19Z",
    transform: "translate(-31.21 -34.19)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLactose);
export default __webpack_public_path__ + "static/media/lactose.c0585a9779b622173fd339fe8b59389f.svg";
export { ForwardRef as ReactComponent };